import React from "react";
import ReactDOM from "react-dom/client";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";

import { msalConfig } from "./msalConfig";

import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import ReadOnlyEditorPage from "./components/ReadOnlyCodeEditor";
import AddParticipant from "./components/AddParticipant";
import AppLayout from "./AppLayout";
import RequireAuth from "./RequireAuth";
import { EventProvider } from "./contexts/EventContext";

import "./index.css";
import { ProfileProvider } from "./contexts/ProfileContext";
import { Toaster } from "react-hot-toast";

const pca = new PublicClientApplication(msalConfig);

pca.initialize().then(() => {
  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
  );

  root.render(
    <React.StrictMode>
      <MsalProvider instance={pca}>
        <ProfileProvider>
          <Router>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                path="/code-viewer"
                element={
                  <RequireAuth>
                    <EventProvider>
                      <Toaster position="top-right" />
                      <ReadOnlyEditorPage />
                    </EventProvider>
                  </RequireAuth>
                }
              />
              <Route
                element={
                  <RequireAuth>
                    <EventProvider>
                      <AppLayout />
                    </EventProvider>
                  </RequireAuth>
                }
              >
                <Route index element={<Dashboard />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="addParticipant" element={<AddParticipant />} />
              </Route>
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          </Router>
        </ProfileProvider>
      </MsalProvider>
    </React.StrictMode>
  );
});
